export const ADMIN = 'admin';
export const MANAGER = 'manager';
export const EMPLOYEE = 'employee';
